import '../assets/css/galleryArtwork.css';

import React from 'react';

export const GalleryArtwork = ({ artwork }) => {
  const picType = artwork.picType.split('/')[0];
  return (
    <div className="card  border-light smallCard">
      <div className="card-header p-3">
        <div className="row">
          <div className="d-flex picaround ">
            { picType === 'video' ? (
                  <video controls className="video">
                    <source src={artwork.artUrl} type={artwork.picType}></source>
                  </video>
                ) : (
                  <img src={artwork.artUrl} className="card-img-top cardpic align-items-center" alt={artwork.name} />
            )}

          </div>
        </div>
      </div>

      <div className="card-body pt-0">
        <div className="d-flex align-items-center justify-content-center ">
          <span className="mr-2"><b><i>{artwork.name}</i></b></span><span>by</span><span className="ml-2">{artwork.author}</span>
        </div>
        <div className="d-flex align-items-center justify-content-center mt-5 ">
        { artwork.left > 0 ? (<span className="nft-infos ml-2">You can mint {artwork.left} of these.</span>) : (<span className="nft-infos ml-2">&nbsp;</span>)}
        </div>
      </div>
    </div>
  );
};
